import { FC, ReactNode } from 'react';
import { Link, NakedButton, Text } from '@qga/roo-ui/components';
import { openLiveChat } from 'lib/liveChat/actions';

import * as track from 'lib/gaTracking/crossPageEvents';
import { CONTACT_US_URL, CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';
import TelLink from 'components/TelLink';

export const ModalBody: FC<{ content: ReactNode; resolution: ReactNode }> = ({ content, resolution }) => (
  <>
    <Text as="p" m={0}>
      {content}
    </Text>
    <Text as="p" mt={4} mb={0}>
      {resolution}
    </Text>
  </>
);

export const ContactUsResolution: FC = () => {
  const handleLiveChatClick = () => {
    openLiveChat();
    track.expiredCreditCardModalLinkSelected('live chat');
  };

  const handleEmailClick = () => {
    track.expiredCreditCardModalLinkSelected('email');
  };

  const handlePhoneClick = () => {
    track.expiredCreditCardModalLinkSelected('call customer support');
  };

  const handleInternationalPhoneClick = () => {
    track.expiredCreditCardModalLinkSelected('call international customer support');
  };

  return (
    <>
      To continue with your booking, please contact us via{' '}
      <Link data-testid="livechat-link" as={NakedButton} onClick={handleLiveChatClick} underline>
        live chat
      </Link>
      ,{' '}
      <Link data-testid="email-link" target="_blank" href={`${CONTACT_US_URL}`} onClick={handleEmailClick} underline>
        email
      </Link>
      , or call{' '}
      <TelLink data-testid="support-phone" number={CUSTOMER_SUPPORT_HOTLINE_AU} color="greys.steel" underline onClick={handlePhoneClick} />{' '}
      (outside Australia:{' '}
      <TelLink
        data-testid="intl-support-phone"
        number={CUSTOMER_SUPPORT_HOTLINE_INTL}
        color="greys.steel"
        underline
        onClick={handleInternationalPhoneClick}
      />
      ).
    </>
  );
};
